import BMVModal from '@/components/fakeDoor/components/mmv/mmvModal';
import { Title } from '@/components/repairTrackingPage/styles';
import Layout from '@/components/common/layout';
import { useEffect, useState } from 'react';
import SearchInput from '@/components/fakeDoor/components/mmv/selectInput';
import { PrimaryButton } from '@acko-tech/building-blocks.ui.button';
import Router from '@/components/common/router';
import { RedirectFrom, ROUTEMAP } from '../../constants';
import { fetchMake, fetchModels, fetchVariants } from './api';
import GlobalLoader from '@/components/common/globalLoader';
import useOnce from '@/hooks/useOnce';
import { viewPageAPI, trackEventAPI } from '@/analytics/middleware';
import {
    VIEW_PAGE_ENTER_MANUAL_CAR_DETAILS,
    TAP_BTN_SUBMIT_MANUAL_CAR_DETAILS,
} from '@/analytics/events';
import { useRouter } from 'next/router';
import { fuelTypeEnum } from '../../constants';
import GarageHeader from '../garageHeader';
import { checkCarIsServiceable } from '../../api';
import NotServiceableModal from '../notServiceableModal';
import { useDispatch, useSelector } from 'react-redux';
import { setVehicleInfo } from '@/store/modules/savedVehicleSlice';
import { fetchOfferValidation } from '@/utils/api';
import styled from 'styled-components';
import { resolvePath } from '@/utils/resolvePath';
import Image from 'next/image';
import { MMV_MODAL_COPY } from './config';
import { formatColor } from '@/utils';
import EvBlockModal from '../evBlockModal';
import SkeletonLoader from '@/components/common/skeletonLoader';
import * as Styles from '../../styles';
import { ELECTRIC, EV } from '@/constants/common';
import { NEW_ROUTEMAP } from '@/constants/routes';
import {
    selectBookingData,
    updateAppointment,
} from '@/store/modules/appointmentBookingSlice';
import { REPEAT_BOOKING } from '@/constants';
import { redirectToLandingPage } from '@/utils/common';

const defaultMMV = { score: '', name: '', id: '' };

function MMV({
    isSeo = false,
    pricingGarageId,
    seoClick,
}: {
    isSeo?: boolean;
    pricingGarageId?: any;
    seoClick?: any;
}) {
    const router = useRouter();
    const dispatch = useDispatch();
    const {
        make: vehicle_make_r = '',
        model: model_r = '',
        variant: variant_r = '',
        fuel_type: fuel_type_r = '',
        redirect_from = '',
        garageId = '',
        is_edit = false,
        carnumber: vehicle_number_r = '',
        is_campaign = '',
        utm_medium = '',
        service_type = '',
        last_service_date = '',
        appointmentId = '',
    } = router.query as {
        make?: string;
        model?: string;
        variant?: string;
        fuel_type?: string;
        redirect_from?: string;
        garageId?: string;
        is_edit?: boolean;
        carnumber?: string;
        is_campaign?: string;
        utm_medium?: string;
        service_type?: string;
        last_service_date?: string;
        appointmentId?: string;
    };
    const selectedGarageData = useSelector((state: any) => {
        return state.currentGarageData?.selectedGarageData;
    });
    const [items, setItems] = useState([]);
    const [isNotServiceable, setIsNotServiceable] = useState(false);
    const [models, setModels] = useState([]);
    const [variants, setVariants] = useState([]);
    const [currentSelection, setCurrentSelection] = useState<
        'MAKE' | 'MODEL' | 'VARIANT' | 'FUEL_TYPE' | 'COLOR_TYPE' | ''
    >('');
    const [colorTypes, setColorTypes] = useState([]);
    const [showModal, setShowModal] = useState(false);
    const [loading, setLoading] = useState(false);
    const [formData, setFormData] = useState({
        make: defaultMMV,
        model: defaultMMV,
        variant: defaultMMV,
        fuel_type: defaultMMV,
        ...(utm_medium?.toLowerCase() === 'qr_online_campaign' && {
            color_type: defaultMMV,
        }),
    });
    const [errorData, setErrorData] = useState({
        make: '',
        model: '',
        variant: '',
        fuel_type: '',
        ...(utm_medium?.toLowerCase() === 'qr_online_campaign' && {
            color_type: '',
        }),
    });

    const [vehicleData, setVehicleData] = useState<any>(null);
    const [vehicle_make, setVehicle_make] = useState('');
    const [model, setModel] = useState('');
    const [variant, setVariant] = useState('');
    const [fuel_type, setFuel_type] = useState('');
    const [color_type, setColor_type] = useState('');
    const [campaignDate, setCampaignDate] = useState('');
    const [offerData, setOfferData] = useState<any>(null);
    const [showEvBlockModal, setShowEvBlockModal] = useState<boolean>(false);
    const [showLoader, setShowLoader] = useState<boolean>(false);
    const [carData, setCarData] = useState<any>();

    const appointmentDetailsStore = useSelector(selectBookingData);

    const handleHomeBack = () => {
        redirectToLandingPage();
    };

    const handleAddCar = () => {
        Router.replace({
            pathname: '/ad-services/location-vehicle-check',
            query: {
                redirect_from: 'periodic',
                loggedin: true,
                newCar: true,
                garageId: garageId || '',
            },
        });
    };

    useEffect(() => {
        if (vehicleData) {
            if (
                Object.keys(vehicleData)?.length === 0 ||
                !vehicleData[vehicle_number_r]
            ) {
                setVehicle_make(vehicle_make_r);
                setModel(model_r);
                setVariant(variant_r);
                setFuel_type(fuel_type_r);
            } else {
                setVehicle_make(vehicleData[vehicle_number_r]?.make || '');
                setModel(vehicleData[vehicle_number_r]?.model || '');
                setVariant(vehicleData[vehicle_number_r]?.variant);
                setFuel_type(vehicleData[vehicle_number_r]?.fuel_type || '');
                setColor_type(vehicleData[vehicle_number_r]?.color || '');
            }
        }
    }, [vehicleData]);
    const itemMap = {
        MAKE: items,
        MODEL: models,
        VARIANT: variants,
        FUEL_TYPE: fuelTypeEnum,
        COLOR_TYPE: colorTypes,
        '': [],
    };

    // async function getColors() {
    //     let tempColors = await fetchColors(garageId);
    //     let addColor = true;
    //     const data = JSON.parse(
    //         localStorage.getItem('originalCarColor') || '{}'
    //     );
    //     let selectedColor = data?.[vehicle_number_r] || '';
    //     tempColors = tempColors.map((tempColor: string) => {
    //         if (tempColor?.toLowerCase() === selectedColor?.toLowerCase()) {
    //             addColor = false;
    //         }
    //         return {
    //             name: tempColor
    //                 ?.split(' ')
    //                 ?.map(
    //                     (color) =>
    //                         color.charAt(0).toUpperCase() +
    //                         color.slice(1).toLowerCase()
    //                 )
    //                 .join(' '),
    //             id: tempColor.toUpperCase(),
    //             score: '',
    //         };
    //     });
    //     if (addColor) {
    //         tempColors.push({
    //             name: selectedColor
    //                 ?.split(' ')
    //                 ?.map(
    //                     (color: any) =>
    //                         color.charAt(0).toUpperCase() +
    //                         color.slice(1).toLowerCase()
    //                 )
    //                 .join(' '),
    //             id: selectedColor.toUpperCase(),
    //             score: '',
    //         });
    //     }

    //     setColorTypes(tempColors);
    // }

    async function getMake() {
        const makes = await fetchMake();
        const selectedMake = makes?.response.find(
            (make: any) =>
                make?.name.toLowerCase() === vehicle_make?.toLowerCase()
        );
        if (vehicle_make && selectedMake?.id) {
            setErrorData({ ...errorData, make: '' });
            setFormData((prevFormData) => ({
                ...prevFormData,
                make: {
                    score: selectedMake?.score || 0,
                    name: selectedMake?.name || '',
                    id: selectedMake?.id,
                },
            }));
            getModels(selectedMake.id);
        }
        const serviceableMakes = makes?.response.filter((make: any) =>
            selectedGarageData?.serviceable_make.includes(
                make.name.toUpperCase()
            )
        );
        setItems(serviceableMakes);
    }

    async function getModels(makeId = '') {
        const models = await fetchModels(makeId || formData.make.id);
        const selectedModel = models?.response.find(
            (vehicleMake: any) =>
                vehicleMake?.name.toLowerCase() === model?.toLowerCase()
        );

        if (model && selectedModel) {
            setErrorData({ ...errorData, model: '' });
            setFormData((prevFormData) => {
                return {
                    ...prevFormData,
                    model: {
                        score: selectedModel?.score || '',
                        name: selectedModel?.name || '',
                        id: selectedModel?.id,
                    },
                };
            });
            getVariants(selectedModel?.id);
        }
        setModels(models?.response);
    }

    async function getVariants(modelId = '') {
        const variants = await fetchVariants(modelId || formData.model.id);
        const selectedVariant = variants?.response.find(
            (vehicleMake: any) =>
                vehicleMake?.id === variant || vehicleMake?.name === variant
        );
        const selectedFuelType = fuelTypeEnum.find(
            (type: any) => type?.name.toLowerCase() === fuel_type?.toLowerCase()
        );
        const selectedColorType = {
            name: color_type
                ?.split(' ')
                ?.map(
                    (color) =>
                        color.charAt(0).toUpperCase() +
                        color.slice(1).toLowerCase()
                )
                .join(' '),
            id: color_type.toUpperCase(),
            score: '',
        };
        if (variant && selectedVariant) {
            setErrorData({ ...errorData, variant: '' });
            setFormData((prevFormData) => {
                return {
                    ...prevFormData,
                    variant: {
                        score: selectedVariant?.score || '',
                        name: selectedVariant?.name || '',
                        id: selectedVariant?.id,
                    },
                    fuel_type: {
                        score: selectedFuelType?.score || '',
                        name: selectedFuelType?.name || '',
                        id: selectedFuelType?.id || '',
                    },
                    ...(utm_medium?.toLowerCase() === 'qr_online_campaign' && {
                        color_type: {
                            score: selectedColorType?.score || '',
                            name: selectedColorType?.name || '',
                            id: selectedColorType?.id || '',
                        },
                    }),
                };
            });
        }
        if (fuel_type && selectedFuelType) {
            setErrorData((prevErrorData) => ({
                ...prevErrorData,
                fuel_type: '',
            }));
            setFormData((prevFormData) => ({
                ...prevFormData,
                fuel_type: {
                    score: selectedFuelType?.score || '',
                    name: selectedFuelType?.name || '',
                    id: selectedFuelType?.id || '',
                },
            }));
        }
        setVariants(variants?.response);
    }

    const getVehicleDetails = () => {
        switch (currentSelection) {
            case 'MAKE':
                getMake();
                setShowModal(true);
                break;

            case 'MODEL':
                if (!formData.make.id) {
                    setErrorData({
                        ...errorData,
                        make: 'Please select a brand',
                    });
                    return;
                }
                getModels();
                setShowModal(true);
                break;

            case 'VARIANT':
                if (!formData.model.id) {
                    setErrorData({
                        ...errorData,
                        model: 'Please select a model',
                    });
                    return;
                }
                getVariants();
                setShowModal(true);
                break;

            case 'FUEL_TYPE':
                setShowModal(true);
                break;
            case 'COLOR_TYPE':
                setShowModal(true);
                break;
        }
    };

    useEffect(() => {
        if (currentSelection) {
            getVehicleDetails();
        }
    }, [currentSelection]);

    useEffect(() => {
        if (vehicle_make && items.length === 0) {
            getMake();
            // flow not being used currently
            // utm_medium?.toLowerCase() === 'qr_online_campaign' && getColors();
        }
    }, [vehicle_make]);

    useEffect(() => {
        if (typeof window !== 'undefined') {
            // const data = JSON.parse(localStorage.getItem('mmv') || '{}');
            const fetchData = async () => {
                const tempOfferData: any = await fetchOfferValidation(
                    garageId as string,
                    vehicle_number_r as string
                );
                setOfferData(tempOfferData);
            };
            const data = JSON.parse(localStorage.getItem('mmvsData') || '{}');
            setVehicleData(data);
            if (utm_medium?.toLowerCase() === 'qr_online_campaign') {
                const tempCampaignDate = JSON.parse(
                    localStorage.getItem('campaignDate') || 'null'
                );
                setCampaignDate(tempCampaignDate);
                fetchData();
            }
        }
    }, []);

    function handleSelection(val: any) {
        switch (currentSelection) {
            case 'MAKE':
                setErrorData({ ...errorData, make: '' });
                setFormData({
                    ...formData,
                    make: val,
                    model: defaultMMV,
                    variant: defaultMMV,
                    fuel_type: defaultMMV,
                });
                break;

            case 'MODEL':
                setErrorData({ ...errorData, model: '' });
                setFormData({
                    ...formData,
                    model: val,
                    variant: defaultMMV,
                    fuel_type: defaultMMV,
                });
                break;

            case 'VARIANT':
                setErrorData({ ...errorData, variant: '' });
                setFormData({ ...formData, variant: val });
                break;
            case 'FUEL_TYPE':
                setFormData({ ...formData, fuel_type: val });
                setErrorData({ ...errorData, fuel_type: '' });
                break;
            case 'COLOR_TYPE':
                setFormData({ ...formData, color_type: val });
                setErrorData({ ...errorData, color_type: '' });
                break;
        }
    }

    function getItemList() {
        return itemMap[currentSelection] || [];
    }

    const validateForm = () => {
        let isValid = true;
        let errors = { ...errorData };
        Object.keys(formData).forEach((item) => {
            // @ts-ignore
            if (!formData[item].name) {
                errors = {
                    ...errors,
                    [item]: `Please select ${
                        item === 'fuel_type'
                            ? 'fuel type'
                            : item === 'color_type'
                              ? 'color type'
                              : item
                    }`,
                };
                isValid = false;
            }
        });
        setErrorData(errors);
        return isValid;
    };

    async function handleSubmit() {
        if (validateForm()) {
            setLoading(true);
            trackEventAPI({
                event_name: TAP_BTN_SUBMIT_MANUAL_CAR_DETAILS,
                customAttributes: {
                    make: formData.make.name,
                    model: formData.model.name,
                    model_id: formData.model.id,
                    registration_number: sessionStorage.getItem(
                        'registration_number'
                    ),
                },
                isFakeDoor: true,
            });
            let isCarServiceable = true;
            if (redirect_from !== RedirectFrom.CAR_SPA_AND_CLEANING) {
                isCarServiceable = await checkCarIsServiceable(
                    isSeo ? (pricingGarageId as string) : (garageId as string),
                    formData.make.name
                );
            }
            const mmvData = {
                make: formData.make.name,
                make_id: formData.make.id,
                model: formData.model.name,
                model_id: formData.model.id as any,
                fuel_type: formData.fuel_type.id,
                variant: formData.variant.name,
                variant_id: formData.variant.id,
                ...(utm_medium?.toLowerCase() === 'qr_online_campaign' && {
                    color: formData?.color_type?.name,
                }),
            };
            const transformedCarData = {
                vehicle_make: mmvData?.make,
                vehicle_model: mmvData?.model,
                model_id: mmvData?.model_id,
                vehicle_number:
                    localStorage.getItem('registration_number') || undefined,
                fuel_type: (() => {
                    return mmvData?.fuel_type?.toUpperCase();
                })(),
                varient: mmvData?.variant,
            };
            setCarData(transformedCarData);
            localStorage.setItem('CarData', JSON.stringify(transformedCarData));
            if (!isSeo) {
                if (isCarServiceable) {
                    localStorage.setItem('mmv', JSON.stringify(mmvData));

                    let mmvsData = JSON.parse(
                        localStorage.getItem('mmvsData') || '{}'
                    );

                    mmvsData[vehicle_number_r] = mmvData;
                    localStorage.setItem('mmvsData', JSON.stringify(mmvsData));
                    localStorage.setItem('vehicleSelected', 'yes');

                    dispatch(
                        setVehicleInfo({
                            carNumber:
                                sessionStorage.getItem('registration_number') ||
                                '',
                            vehicleDetails: mmvData,
                            hasSavedVehicle: true,
                        })
                    );

                    if (utm_medium?.toLowerCase() === 'qr_online_campaign') {
                        Router.push(
                            `${ROUTEMAP.GARAGE_QR_CAMAPIGN_VERIFICATION}?loggedin=true&carNumber=${vehicle_number_r}&color=${formData?.color_type?.name.toLowerCase()}`
                        );
                    } else {
                        if (
                            (mmvData?.fuel_type.toUpperCase() === EV ||
                                mmvData?.fuel_type.toUpperCase() ===
                                    ELECTRIC) &&
                            redirect_from === RedirectFrom.PERIODIC_SERVICE
                        ) {
                            setShowEvBlockModal(true);
                            setShowLoader(true);
                            setLoading(false);
                        } else {
                            const getPath = () => {
                                if (redirect_from === 'pricecheckcta')
                                    return ROUTEMAP.GARAGE_PRICING_PLANS;
                                if (redirect_from === 'sr-pricecheck-cta')
                                    return ROUTEMAP.GARAGE_SPECIFIC_REPAIR;
                                if (redirect_from === 'v1_flow')
                                    return ROUTEMAP.HOME;
                                if (redirect_from === REPEAT_BOOKING)
                                    return NEW_ROUTEMAP.REPEAT_BOOKING;
                                if (
                                    redirect_from ===
                                    RedirectFrom.PERIODIC_SERVICE
                                )
                                    return ROUTEMAP.GARAGE_PRICING_PLANS;
                                return ROUTEMAP.GARAGE_PICK_DROP;
                            };
                            let query;
                            if (redirect_from === REPEAT_BOOKING) {
                                let newPayload = {
                                    ...appointmentDetailsStore.data,
                                    vehicle_details: {
                                        ...appointmentDetailsStore.data
                                            .vehicle_details,
                                        ...mmvData,
                                    },
                                };
                                await dispatch(updateAppointment(newPayload));
                                query = {
                                    vehicle_registration_number:
                                        vehicle_number_r,
                                    garage_id: garageId,
                                    service_type,
                                    last_service_date,
                                    appointmentId,
                                };
                            } else {
                                query = {
                                    vehicle_id: formData.model.id,
                                    fuel_type: formData.fuel_type.id,
                                    carnumber: vehicle_number_r,
                                    redirect_from:
                                        redirect_from === 'v1_flow'
                                            ? 'v1_flow'
                                            : redirect_from,
                                };
                            }
                            Router.push({
                                pathname: getPath(),
                                query,
                            });
                        }
                    }
                } else {
                    setIsNotServiceable(true);
                    setLoading(false);
                }
            } else {
                seoClick(mmvData);
                setLoading(false);
            }
        }
    }
    useOnce(() => {
        viewPageAPI({
            event_name: VIEW_PAGE_ENTER_MANUAL_CAR_DETAILS,
            customAttributes: {
                registration_number: sessionStorage.getItem(
                    'registration_number'
                ),
            },
            isFakeDoor: true,
        });
    });

    if (loading) {
        return <GlobalLoader forceLoad />;
    }

    if (showEvBlockModal && showLoader) {
        return (
            <>
                <Styles.Wrapper>
                    <SkeletonLoader />
                </Styles.Wrapper>
                <EvBlockModal
                    show={showEvBlockModal}
                    close={() => {
                        setShowEvBlockModal(false);
                    }}
                    clickCarHandler={handleAddCar}
                    clickHomeHandler={handleHomeBack}
                    carData={carData}
                />
            </>
        );
    }

    return (
        <>
            <Layout hideHeader {...(isSeo ? { minHeight: '0' } : {})}>
                {isSeo ? (
                    <></>
                ) : (
                    <GarageHeader showHelp title={<>Select car details</>} />
                )}
                <div style={{ margin: '40px 0' }}>
                    <div
                        style={{ margin: '20px 0' }}
                        onClick={() => setCurrentSelection('MAKE')}
                    >
                        <SearchInput
                            placeholder="Select make"
                            value={formData.make.name || ''}
                        />
                        <div className="error">{errorData.make}</div>
                    </div>
                    <div
                        onClick={() => setCurrentSelection('MODEL')}
                        style={{ margin: '20px 0' }}
                    >
                        <SearchInput
                            placeholder="Select model"
                            value={formData.model.name || ''}
                        />
                        <div className="error">{errorData.model}</div>
                    </div>
                    <div
                        onClick={() => setCurrentSelection('VARIANT')}
                        style={{ margin: '20px 0' }}
                    >
                        <SearchInput
                            placeholder="Select variant"
                            value={formData.variant.name || ''}
                        />
                        <div className="error">{errorData.variant}</div>
                    </div>

                    <div
                        onClick={() => setCurrentSelection('FUEL_TYPE')}
                        style={{ margin: '20px 0' }}
                    >
                        <SearchInput
                            placeholder="Select fuel type"
                            value={formData.fuel_type.name || ''}
                        />
                        <div className="error">{errorData.fuel_type}</div>
                    </div>
                    {utm_medium?.toLowerCase() === 'qr_online_campaign' && (
                        <div
                            onClick={() => setCurrentSelection('COLOR_TYPE')}
                            style={{ margin: '20px 0' }}
                        >
                            <SearchInput
                                placeholder="Select Color type"
                                value={formData?.color_type?.name || ''}
                            />
                            <div className="error">{errorData.color_type}</div>
                        </div>
                    )}
                    {utm_medium?.toLowerCase() === 'qr_online_campaign' && (
                        <NoteWrapper>
                            <Image
                                src={resolvePath(
                                    '/images/qr/information_tips_bulb.svg'
                                )}
                                width={16}
                                height={16}
                            />
                            <NoteTextWrapper>
                                This offer is applicable only for{' '}
                                {formatColor(
                                    offerData?.availableColors || 'White'
                                )}
                                -colored, private 4-wheeler cars serviced till{' '}
                                {campaignDate}
                            </NoteTextWrapper>
                        </NoteWrapper>
                    )}
                </div>
                <BMVModal
                    isMobile={true}
                    heading={
                        currentSelection
                            ? `Choose your ${MMV_MODAL_COPY[currentSelection]}`
                            : ''
                    }
                    showModal={showModal}
                    itemsStatus={undefined}
                    closeModal={() => {
                        setShowModal(false);
                        setCurrentSelection('');
                    }}
                    getSelectedItem={(item: any) => {
                        handleSelection(item);
                        setShowModal(false);
                        setCurrentSelection('');
                    }}
                    items={getItemList()}
                    placeholder={
                        currentSelection
                            ? `Search ${MMV_MODAL_COPY[currentSelection]}`
                            : ''
                    }
                />
                <NotServiceableModal
                    show={isNotServiceable}
                    close={() => {
                        setIsNotServiceable(false);
                    }}
                    clickHandler={() => setIsNotServiceable(false)}
                    isNewFlow
                    editCarModal={false}
                    make={formData.make.name || ''}
                />
                <div className="fixed-wrapper">
                    <PrimaryButton onClick={handleSubmit}>
                        {utm_medium?.toLowerCase() === 'qr_online_campaign'
                            ? 'Proceed to confirm'
                            : 'Next'}
                    </PrimaryButton>
                    {utm_medium?.toLowerCase() === 'qr_online_campaign' && (
                        <DifferentColorWrapper
                            onClick={() =>
                                Router.push(`${ROUTEMAP.GARAGE_QR_CAMPAIGN}`)
                            }
                        >
                            Not this car? Add another
                        </DifferentColorWrapper>
                    )}
                </div>
                <></>
            </Layout>
            <style jsx>{`
                .error {
                    font-size: 12px;
                    color: red;
                    padding: 5px;
                }
            `}</style>
        </>
    );
}

const NoteWrapper = styled.div`
    display: flex;
    padding: var(--spacing-12px, 12px);
    align-items: flex-start;
    gap: var(--spacing-8px, 8px);
    align-self: stretch;
    border-radius: var(--B-radius-16px, 16px);
    background: var(--Yellow-Y50, #fff7e5);
    margin-bottom: 128px;
`;

const NoteTextWrapper = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;
    gap: 4px;
    flex: 1 0 0;
    align-self: stretch;
    color: var(--Yellow-Y500, #d16900);
    font-family: 'Euclid Circular B';
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: 18px;
`;

const DifferentColorWrapper = styled.div`
    color: var(--button-hyperlink-b-300, #1b73e8);
    font-family: 'Euclid Circular B';
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: 20px;
    text-align: center;
    padding-top: 16px;
`;

export default MMV;
